import { render } from "./FormularioBaseEnderecoFormulario.vue?vue&type=template&id=dbb0a33e&scoped=true"
import script from "./FormularioBaseEnderecoFormulario.vue?vue&type=script&lang=js"
export * from "./FormularioBaseEnderecoFormulario.vue?vue&type=script&lang=js"

import "./FormularioBaseEnderecoFormulario.vue?vue&type=style&index=0&id=dbb0a33e&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb0a33e"],['__file',"src/components/FormularioBaseEndereco/FormularioBaseEnderecoFormulario.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dbb0a33e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dbb0a33e', __exports__)) {
    console.log('reload')
    api.reload('dbb0a33e', __exports__)
  }
  
  module.hot.accept("./FormularioBaseEnderecoFormulario.vue?vue&type=template&id=dbb0a33e&scoped=true", () => {
    console.log('re-render')
    api.rerender('dbb0a33e', render)
  })

}


export default __exports__